import { assert } from 'superstruct';
import httpClient from '../../shares/api/httpClient';
import { OTPResponseSchema } from '../../shares/model/config';
import { hideLoader, showError } from '../../shares/lib/otpUtils';
import OTPProvider from './OTPProvider';

interface OTPApiResponse {
  data?: string;
  error?: { code?: number; message?: string };
}

class ApiOTPProvider extends OTPProvider {
  async getOTP(gameId?: string): Promise<string | undefined> {
    return await this.callOTPApiEndpoint();
  }

  private async callOTPApiEndpoint(): Promise<string | undefined> {
    try {
      const apiResponse: OTPApiResponse = await httpClient(
        'GET',
        this.otpConfig.remoteApiEndPoint as string,
        { ...this.otpConfig.requestHeaders },
      );

      assert(apiResponse, OTPResponseSchema);
      const { data, error } = apiResponse;

      if (error?.code && error.code !== 0) {
        throw new Error(error.message);
      }

      if (!data) {
        throw new Error('Data Not Found');
      }

      return data;
    } catch (error) {
      showError('OTP Generation failed', error);
      return undefined;
    } finally {
      hideLoader();
    }
  }
}

export default ApiOTPProvider;
